<template>
  <div class='menu-wrapper'>
    <template v-for="item in routes">

      <!-- <router-link v-if="!item.hidden&&item.noDropdown&&item.children.length>0" :to="item.path+'/'+item.children[0].path">
        <el-menu-item :index="item.path+'/'+item.children[0].path" class='submenu-title-noDropdown'>
          <i v-if='item.icon' :class="item.icon"></i><span>{{item.children[0].name}}</span>
        </el-menu-item>
      </router-link> -->
      <!-- parentName为空的部分显示在第一层菜单 -->
      <el-submenu :index="item.name" v-if="!item.parentName&&!item.hidden">
        <template slot="title">
          <i v-if='item.icon' :class="item.icon"></i><span>{{item.name}}</span>
        </template>

        <template v-for="child in routes" v-if="!child.hidden && child.parentName 
                      && child.parentName === item.path">

          <sidebar-item class='nest-menu' v-if='child.children&&child.children.length>0' :routes='[child]'> </sidebar-item>
          <router-link :to="child.path">
            <el-menu-item :index="'/' + child.rootpath + '/' + child.path">
              <span>{{child.name}}</span>
            </el-menu-item>
          </router-link>

        </template>

      </el-submenu>

    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SidebarItem',
  computed: {
    ...mapGetters([
      'tools_app'
    ])
  },
  activated() {
    console.info('tools_app' + tools_app)
  },
  data() {
    return {
    }
  },
  props: {
    routes: {
      type: Array
    }
  }
}
</script>
<style scoped>
</style>




// WEBPACK FOOTER //
// SidebarItem.vue?65cad029